import Button from '@veneer/core/dist/esm/scripts/button'
import TextArea from '@veneer/core/dist/esm/scripts/text_area'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { State } from '../../common/types'
import config from '../../config'
import { apiExternalUrl } from '../../services/axiosConfig'
import { getEnvironment } from '../../util'
import bff from '../../services'
import { useNavigate } from 'react-router-dom'
import { PAGE_USERNAME } from '../../constants'
import InlineNotification from '@veneer/core/dist/esm/scripts/inline_notification'
import udlEvents from '../../common/udlEvents'
import * as S from './style'

const VALID_CLIENT_FOR_ARKOSE_TEST = '@hpid-test-arkose-disabled@'
const version = '4.70.0'

const SessionInfo = () => {
  const dispatch = useDispatch()
  const [response, setResponse] = useState('No info yet...')
  const [responseSessionInfo, setResponseSessionInfo] = useState(null)
  const [errorResponse, setErrorResponse] = useState(null)
  const [successMessage, setSuccessMessage] = useState(null)
  const state = useSelector((state: State) => state)
  const navigate = useNavigate()
  const error = errorResponse?.error

  useEffect(() => {
    handleFetchSessionInfo()
    setErrorResponse('')
    setSuccessMessage('')
    const getEnv = getEnvironment()
    console.info(`${version} :`, getEnv)
    // eslint-disable-next-line
  }, [])

  const getUserInfo = async () => {
    setErrorResponse('')
    setSuccessMessage('')
    const geoLookup = await apiExternalUrl.get(config.geoURL)
    let countryOfResidence = {
      currentCountry: state.user.country,
      queryParameter: state.user.queryCountryParam,
      geolookupCountry: geoLookup.data.country
    }
    const locale = {
      currentLocale: state.user.locale,
      queryParameter: state.user.queryLocaleParam,
      browserLanguage: navigator.language
    }
    const lastArkoseSession = state.arkose.lastArkoseSession
    return { lastArkoseSession, countryOfResidence, locale }
  }

  const handleFetchSessionInfo = async () => {
    setResponse('Fetching info...')
    try {
      const sessionInfo = await dispatch.session.fetchSessionCustomInfo()
      const userInfo = await getUserInfo()

      /* Delete unnecessary data from response */
      delete sessionInfo.config
      delete sessionInfo.request
      delete sessionInfo.data.idp
      delete sessionInfo.data.captchaEngines

      setResponse(JSON.stringify({ sessionInfo, ...userInfo }, null, 2))
      setResponseSessionInfo(sessionInfo)
    } catch (error) {
      setResponse(JSON.stringify(error, null, 2))
    }
  }

  const handleEnableArkose = async () => {
    setErrorResponse('')
    setSuccessMessage('')
    try {
      const { data } = await bff.enableArkoseDev()
      setSuccessMessage(data.msg)
    } catch (error) {
      setErrorResponse(error)
      console.error('Error: ', error)
    }
  }

  const handleDisableArkose = async () => {
    setErrorResponse('')
    setSuccessMessage('')
    try {
      const { data } = await bff.disableArkoseDev()
      setSuccessMessage(data.msg)
    } catch (error) {
      setErrorResponse(error)
      console.error('Error: ', error)
    }
  }

  const renderArkoseButtons = () => {
    const getEnv = getEnvironment()
    const isClientIdValid = responseSessionInfo?.data?.client?.clientId === VALID_CLIENT_FOR_ARKOSE_TEST
    if (getEnv === 'qa' || getEnv === 'dev') {
      return (
        <>
          <S.ButtonWrapper>
            <Button
              type="button"
              colorScheme="positive"
              id="enable-arkose-button"
              appearance="secondary"
              onClick={handleEnableArkose}
              disabled={!isClientIdValid}
              expanded
            >
              Enable Arkose
            </Button>
          </S.ButtonWrapper>
          <S.ButtonWrapper>
            <Button
              type="button"
              colorScheme="negative"
              id="disable-arkose-button"
              appearance="secondary"
              onClick={handleDisableArkose}
              disabled={!isClientIdValid}
              expanded
            >
              Disable Arkose
            </Button>
          </S.ButtonWrapper>
        </>
      )
    }
    return []
  }

  const handleBack = () => {
    dispatch.udl.trackEvent(udlEvents.getEventByID('EVENT220'))
    navigate(PAGE_USERNAME)
  }

  return (
    <S.SessionInfoWrapper>
      <S.ButtonContainer>
        <S.ButtonWrapper>
          <Button type="button" id="fetch-button" onClick={handleFetchSessionInfo} expanded>
            Fetch info
          </Button>
        </S.ButtonWrapper>
        <S.ButtonWrapper>
          <Button
            type="button"
            id="back-button"
            appearance="secondary"
            colorScheme="warning"
            onClick={handleBack}
            expanded
          >
            Back
          </Button>
        </S.ButtonWrapper>

        {renderArkoseButtons()}
      </S.ButtonContainer>

      <S.Error>
        {successMessage && (
          <InlineNotification
            actionPlacement="top"
            closeButton={true}
            onClose={() => {
              setSuccessMessage('')
            }}
            customStyle={{ width: '100%' }}
            description={successMessage && successMessage}
            title="Success"
            type="positive"
          />
        )}

        {error && (
          <InlineNotification
            actionPlacement="top"
            closeButton={true}
            onClose={() => {
              setErrorResponse('')
            }}
            customStyle={{ width: '100%' }}
            description={error && error}
            title="Error"
            type="negative"
          />
        )}
      </S.Error>
      <S.PanelWrapper>
        <TextArea id="text-info-id" value={response} readOnly height="700px" />
      </S.PanelWrapper>
    </S.SessionInfoWrapper>
  )
}

export default SessionInfo
